import React from 'react'
import Button from '../../../../../UI/Button'
import ModalWrapper from '../../../../../UI/ModalWrapper'
import { Link } from 'react-router-dom'

const SosModal = ({ onCloseModal }) => {
    return (
        <ModalWrapper>
            <div className="bg-white rounded-3xl text-xl !text-center font-ubuntu px-12 py-12 w-[35vw]">

                <div className="font-semibold text-[25px] text-[#F76411]">
                    SOS
                </div>

                <div class="w-full mt-6 mb-0">
                    <div className="text-gray-500 text-sm text-left mb-6"><strong>Disclaimer:</strong> This is not a Hapsmiths service. If you’re feeling unsafe or overwhelmed, you’re not alone.</div>
                    <div className="text-gray-500 text-sm text-left mb-6">For immediate help, please contact your local emergency services or a crisis helpline in your area.</div>
                    <div>
                        <span className='block font-semibold text-[#F76411] text-[20px]'>Global Crisis Support</span>
                        {/* <span className='block font-semibold text-[18px'>Parivarthan</span> */}
                        <span className='block text-sm'>Find verified crisis helplines for your country at:</span>
                        <a href="https://findahelpline.com" target="_blank"
  rel="noopener noreferrer"
  className="text-lightOrange text-[18px] mt-2 block"
>findahelpline.com</a>
                    </div>
                </div>
                <div className="flex justify-evenly gap-12 w-full mt-4 text-center">
                    <Button onClick={onCloseModal} className="bg-[#FFDBB0] text-lightOrange font-ubuntu font-bold py-2 rounded-full min-w-[120px] mt-7 text-[16px]">Close</Button>
                </div>
            </div>
        </ModalWrapper>
    )
}

export default SosModal